import { jsxs as g, jsx as n } from "react/jsx-runtime";
import _ from "react";
import { u as s } from "./index-6a632112.mjs";
import { s as a, b as x, r as C, d as B, a as z, e as R } from "./themes-5f0b3c3d.mjs";
import { l as I } from "./lineHeights-72d3110c.mjs";
import { S as k } from "./types-b577bf77.mjs";
import { S as M } from "./caretRight-e0ea6357.mjs";
import { useAccessibilityProps as P } from "./accessibility.js";
function D({
  title: t,
  titleId: e,
  size: i,
  height: o,
  width: r,
  ...d
}) {
  const l = i ? k[i] : k.s;
  return /* @__PURE__ */ g(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: i ? l : o || l,
      width: i ? l : r || l,
      "aria-labelledby": e,
      ...d,
      children: [
        t ? /* @__PURE__ */ n("title", { id: e, children: t }) : null,
        /* @__PURE__ */ n("g", { clipPath: "url(#Caret-Right__Filled_svg__a)", children: /* @__PURE__ */ n(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M36 1.5c19.054 0 34.5 15.446 34.5 34.5 0 19.054-15.446 34.5-34.5 34.5C16.946 70.5 1.5 55.054 1.5 36 1.5 16.946 16.946 1.5 36 1.5Zm-5.576 14.2-6.098 6.1 14.2 14.2-14.2 14.2 6.098 6.1 20.3-20.3-20.3-20.3Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", { id: "Caret-Right__Filled_svg__a", children: /* @__PURE__ */ n("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
const y = {
  xs: "24px",
  s: "40px",
  m: "56px",
  l: "72px"
}, F = (t, e, i, o) => `
    padding: var(--semantic-spacing-2-x, ${a["2x"]}) var(--semantic-spacing-3-x, ${a["3x"]});
    border-radius: var(--semantic-radius-medium-8-px, ${C["2x"]});
    border: ${x["1x"]} solid var(--semantic-color-stroke-default, ${o.components.dataList.borderColor});
    box-sizing: border-box;
    background: ${i ? `${o.components.dataList.staticBgColor}` : t ? `var(--semantic-color-fill-neutral-subtle, ${o.components.dataList.activeBgColor})` : `var(--semantic-color-fill-default, ${o.components.dataList.defaultBgColor})`};
    cursor: ${e ? "pointer" : "default"};
  `, j = (t, e, i, o) => `
    padding: var(--semantic-spacing-3-x, ${a["3x"]});
    background: ${i ? `${o.components.dataList.staticBgColor}` : t ? `var(--semantic-color-fill-neutral-subtle, ${o.components.dataList.activeBgColor})` : `var(--semantic-color-fill-default, ${o.components.dataList.defaultBgColor})`};
    cursor: ${e ? "pointer" : "default"};
  `, T = s.div`
  ${({ $type: t, $isActive: e, $hasEvent: i, theme: o, $static: r }) => t === "boxed" ? F(e, i, r, o) : t === "action" ? j(e, i, r, o) : `
      padding: var(--semantic-spacing-3-x, ${a["3x"]}) var(--semantic-spacing-0-x, 0px);
      background: ${e ? `var(--semantic-color-fill-neutral-subtle, ${o.components.dataList.staticBgColor})` : `var(--semantic-color-fill-default,  ${o.components.dataList.defaultBgColor})`};
    `};

  &:hover {
    background-color: ${({ $static: t, theme: e }) => t ? e.components.dataList.staticBgColor : e.components.dataList.hoverBgColor};
  }

  &:focus-visible:not([disabled]) {
    ${(t) => t.$type === "boxed" ? `
          outline: ${x["2x"]} solid
              ${t.theme.components.dataList.focusRingColor};
          border-radius: ${C["2x"]};
          outline-offset:2px;
          z-index: 2;
        ` : `
        && > div {
          outline: ${x["2x"]} solid
            ${t.theme.components.dataList.focusRingColor};
          border-radius: ${C["1x"]};
          outline-offset:2px;
          z-index: 2;
        }
        outline: none;
      `}
  }

  && > div {
    display: flex;
    flex-direction: row;
    gap: ${a["2x"]};
    align-items: center;
    z-index: 1;
  }
`, Z = s.div`
  display: flex;
  flex-direction: ${({ $swapLabels: t }) => t ? "column-reverse" : "column"};
  width: 100%;
`, K = s.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  color: var(
    --semantic-color-text-default,
    ${({ theme: t }) => t.components.dataList.contentColor}
  );

  /* body/medium/M */
  font-family: ${B.body};
  font-size: ${z.small};
  font-style: normal;
  font-weight: ${R.medium.M.fontWeight};
  line-height: 150%;
`, N = s.div`
  display: flex;
  flex-direction: row;
  gap: ${a["2x"]};
  align-items: center;

  color: var(
    --semantic-color-text-subtlest,
    ${({ theme: t }) => t.components.dataList.secondaryContentColor}
  );

  /* body/regular/S */
  font-family: ${B.body};
  font-size: ${z.xsmall};
  font-style: normal;
  font-weight: ${R.regular.S.fontWeight};
  line-height: ${I.small};
`, q = s.div`
  z-index: 1;
  ${({ $type: t, $static: e, theme: i }) => {
  if (e)
    return `
        border-bottom: ${x["1x"]} solid ${i.components.dataList.borderColor};
        margin: unset;
      `;
  if (t === "action")
    return `
        border-bottom: ${x["1x"]} solid ${i.components.dataList.borderColor};
        margin: -1px ${a["3x"]} 0;
      `;
}}
`, G = s.div`
  display: flex;
  align-items: center;
  && > img {
    ${({ $size: t }) => {
  let e = y.l;
  return t === "xs" && (e = y.xs), t === "s" && (e = y.s), t === "m" && (e = y.m), `
        height: ${e};
        width: ${e};
      `;
}}
    border-radius: var(--semantic-radius-none, ${C["1x"]});
  }
`, J = s.div`
  display: flex;
  align-self: center;
`, S = s.div`
  color: var(
    --semantic-color-text-subtlest,
    ${({ theme: t }) => t.components.dataList.secondaryContentColor}
  );

  /* body/regular/S */
  font-family: ${B.body};
  font-size: ${z.xsmall};
  font-style: normal;
  font-weight: ${R.regular.S.fontWeight};
  line-height: ${I.small};
  align-self: ${(t) => t.$trailingElementAlignment === "top" ? "flex-start" : "center"};
  display: flex;
  svg {
    color: ${({ theme: t }) => t.components.dataList.trailingColor};
  }
`, A = ({
  label: t,
  description: e,
  leadingElement: i,
  leadingElementSize: o = "l",
  trailingElement: r,
  trailingElementAlignment: d = "center",
  secondaryIcon: l,
  isStatic: L = !1,
  _selectHandler: m,
  _type: f = "action",
  _static: $ = !1,
  _hasRule: u = !1,
  className: W,
  isActive: h = !1,
  swapLabels: v = !1,
  accessibilityOptions: w = {},
  value: b
}) => {
  const c = $ || L, E = P("listitem", {
    ...w
  });
  return /* @__PURE__ */ g("li", { children: [
    /* @__PURE__ */ n(
      T,
      {
        tabIndex: c ? void 0 : 0,
        onKeyDown: (p) => {
          (p.code === "Space" || p.code === "Enter") && m && m(p, t, b);
        },
        className: W,
        $type: f,
        $isActive: h,
        $static: c,
        $hasRule: u,
        $hasEvent: !!m,
        onClick: (p) => m && m(p, t, b),
        ...E,
        children: /* @__PURE__ */ g("div", { children: [
          i && /* @__PURE__ */ n(G, { $size: o, children: i }),
          /* @__PURE__ */ g(Z, { tabIndex: -1, $swapLabels: v, children: [
            /* @__PURE__ */ n(K, { $type: f, $static: c, children: /* @__PURE__ */ n("div", { className: "title", children: t }) }),
            /* @__PURE__ */ g(N, { $type: f, $static: c, children: [
              l && /* @__PURE__ */ n(J, { children: l }),
              e
            ] })
          ] }),
          r ? r !== "none" ? /* @__PURE__ */ n(
            S,
            {
              $trailingElementAlignment: d,
              children: r
            }
          ) : null : c ? /* @__PURE__ */ n(
            S,
            {
              $trailingElementAlignment: d,
              style: { padding: a["1x"] },
              children: /* @__PURE__ */ n(M, { size: "xxs" })
            }
          ) : /* @__PURE__ */ n(
            S,
            {
              $trailingElementAlignment: d,
              children: /* @__PURE__ */ n(D, { size: "xs" })
            }
          )
        ] })
      }
    ),
    u && f !== "boxed" && /* @__PURE__ */ n(q, { $type: f, $isActive: h, $static: c })
  ] });
}, O = s.ul`
  list-style: none;
  padding: unset;
  margin: unset;
  height: auto;
  display: flex;
  flex-direction: column;

  ${({ $type: t }) => {
  if (t === "boxed")
    return `gap: ${a["2x"]}`;
}};
`, Q = ({
  children: t,
  uniqueIdentifier: e,
  ariaLabel: i,
  onChange: o = null,
  type: r = "default",
  isStatic: d = !1,
  className: l,
  hasRule: L = !1
}) => /* @__PURE__ */ n(
  O,
  {
    $type: r,
    "aria-label": i,
    className: l,
    id: e,
    children: ((f) => {
      let $ = !0;
      return _.Children.map(f, (u, W) => {
        if (u.type === A) {
          const h = u.props;
          let v = !1;
          return h.isActive && $ && (v = !0, $ = !1), _.cloneElement(u, {
            _type: r,
            _selectHandler: !d && o ? (w, b, c) => o(w, b, c) : null,
            isActive: v,
            _hasRule: L,
            _static: d
          });
        }
        return null;
      });
    })(t)
  }
);
Q.Item = A;
export {
  Q as DataList
};
